// Central content inventory for Phoenix Roofing & Chimney.
// All images are self-hosted under /assets for reliability.

export const SITE = {
  name: 'Phoenix Roofing & Chimney',
  phone: '+1 (201) 249-2388',
  phoneHref: 'tel:+12012492388',
  whatsapp: 'https://wa.me/12012492388',
  email: 'info@phoenixroofingandchimney.com',
  address: '144 Hunter St, Lodi, NJ 07644',
  addressMapHref: 'https://www.google.com/maps/search/?api=1&query=144+Hunter+St+Lodi+NJ+07644',
  logoBlack: '/assets/phoenix-logo.png',
  logoWhite: '/assets/phoenix-logo-white.png',
  // Owner-provided homepage banner artwork (includes baked-in headline & CTA)
  heroBanner: '/assets/img/hero-banner.jpg',
  // Clean background photo used behind sub-page hero titles
  heroImage: '/assets/img/hero-home.jpg',
};

export const NAV = {
  roofing: [
    { label: 'Roof Replacement', path: '/services/roof-replacement' },
    { label: 'Roof Repair', path: '/services/roof-repair' },
    { label: 'New Roof', path: '/services/new-roof' },
    { label: 'Roof Leak Repair', path: '/services/roof-leak-repair' },
    { label: 'Emergency Roofing', path: '/services/emergency-roofing' },
  ],
  chimney: [
    { label: 'Chimney Inspection', path: '/services/chimney-inspection' },
    { label: 'Chimney Repair', path: '/chimney-repair' },
    { label: 'Chimney Cleaning', path: '/services/chimney-cleaning' },
    { label: 'Cap & Crown Install', path: '/services/cap-crown-install' },
    { label: 'Chimney Flashing Repair', path: '/services/chimney-flashing-repair' },
  ],
};

export const COUNTIES = [
  { name: 'Bergen County', slug: 'bergen-county' },
  { name: 'Passaic County', slug: 'passaic-county' },
  { name: 'Hudson County', slug: 'hudson-county' },
  { name: 'Essex County', slug: 'essex-county' },
  { name: 'Morris County', slug: 'morris-county' },
  { name: 'Hunterdon County', slug: 'hunterdon-county' },
  { name: 'Somerset County', slug: 'somerset-county' },
  { name: 'Sussex County', slug: 'sussex-county' },
  { name: 'Union County', slug: 'union-county' },
  { name: 'Warren County', slug: 'warren-county' },
];

export const CITIES = {
  'bergen-county': [
    { name: 'Wyckoff', zip: '07481', slug: 'bergen-county-roof-repair-replacement-wyckoff-nj07481' },
    { name: 'Wood-Ridge', zip: '07075', slug: 'bergen-county-roof-repair-replacement-wood-ridge-nj07075' },
    { name: 'Woodcliff Lake', zip: '07677', slug: 'bergen-county-roof-repair-replacement-woodcliff-lake-nj07677' },
    { name: 'Westwood', zip: '07675', slug: 'bergen-county-roof-repair-replacement-westwood-nj07675' },
    { name: 'Wallington', zip: '07057', slug: 'bergen-county-roof-repair-replacement-wallington-nj07057' },
    { name: 'Waldwick', zip: '07463', slug: 'bergen-county-roof-repair-replacement-waldwick-nj07463' },
    { name: 'Upper Saddle River', zip: '07458', slug: 'bergen-county-roof-repair-replacement-upper-saddle-river-nj07458' },
    { name: 'Teterboro', zip: '07608', slug: 'bergen-county-roof-repair-replacement-teterboro-nj07608' },
    { name: 'Tenafly', zip: '07670', slug: 'bergen-county-roof-repair-replacement-tenafly-nj07670' },
    { name: 'Teaneck', zip: '07666', slug: 'bergen-county-roof-repair-replacement-teaneck-nj07666' },
    { name: 'South Hackensack', zip: '07606', slug: 'bergen-county-roof-repair-replacement-south-hackensack-nj07606' },
    { name: 'Saddle River', zip: '07458', slug: 'bergen-county-roof-repair-replacement-saddle-river-nj07458' },
    { name: 'Saddle Brook', zip: '07663', slug: 'bergen-county-roof-repair-replacement-saddle-brook-nj07663' },
    { name: 'Rutherford', zip: '07070', slug: 'bergen-county-roof-repair-replacement-rutherford-nj07070' },
  ],
  'hudson-county': [
    { name: 'Bayonne', slug: 'locations/new-jersey/hudson-county/chimney-sweep-in-bayonne-nj' },
    { name: 'Hoboken', slug: 'locations/new-jersey/hudson-county/chimney-sweep-in-hoboken-nj' },
    { name: 'Weehawken', slug: 'locations/new-jersey/hudson-county/chimney-sweep-in-weehawken-nj' },
    { name: 'Union City', slug: 'locations/new-jersey/hudson-county/chimney-sweep-in-union-city-nj' },
    { name: 'Jersey City', slug: 'locations/new-jersey/hudson-county/chimney-sweep-in-jersey-city-nj' },
    { name: 'East Newark', slug: 'locations/new-jersey/hudson-county/chimney-inspections-in-east-newark-nj' },
    { name: 'Guttenberg', slug: 'locations/new-jersey/hudson-county/chimney-inspections-in-guttenberg-nj' },
    { name: 'Harrison', slug: 'locations/new-jersey/hudson-county/chimney-inspections-in-harrison-nj' },
    { name: 'Kearny', slug: 'locations/new-jersey/hudson-county/chimney-inspections-in-kearny-nj' },
    { name: 'West New York', slug: 'locations/new-jersey/hudson-county/chimney-inspections-in-west-new-york-nj' },
    { name: 'Secaucus', slug: 'locations/new-jersey/hudson-county/chimney-inspections-in-secaucus-nj' },
    { name: 'North Bergen', slug: 'locations/new-jersey/hudson-county/chimney-inspections-in-north-bergen-nj' },
  ],
};

export const ROOF_TYPES = [
  {
    title: 'FLAT ROOFING',
    image: `/assets/img/flat-roofing-qr6yfp70lylbdyg0eahqokgmgpncp34ws3ra1er4pc.jpg`,
    text: 'Specialised flat roofing solutions for commercial and residential properties.',
  },
  {
    title: 'Asphalt Shingle Roof',
    image: `/assets/img/aspghalt-shingle-roofing-nj-qr6yfq4ussmlpken8swd928323ipws8n48eriopqj4.jpg`,
    text: 'High-quality asphalt shingle roofs for an affordable and attractive finish.',
  },
  {
    title: 'SLATE ROOFING',
    image: `/assets/img/slate-roofing-new-jersey-qr6yfs0j6gp6csbwxtpme1r08v9gc6g3shpqh8my6o.png`,
    text: 'Elegant and durable slate roofing for a timeless look and superior performance.',
  },
  {
    title: 'METAL ROOFING',
    image: `/assets/img/metal-roofing-nj-qr6yfp70lylbdyg0eahqokgmgpncp34ws3ra1er4pc.webp`,
    text: 'Sturdy and weather-resistant metal roofing for maximum protection and longevity.',
  },
];

export const SERVICES_GRID = [
  {
    title: 'Roofing',
    icon: `/assets/img/ROOFING-NJ.png`,
    text: 'If the roof only needs to be repaired, our professionals have the expertise to solve the problem permanently.',
    path: '/services/roof-repair',
  },
  {
    title: 'Chimney',
    icon: `/assets/img/CHIMNEY.png`,
    text: 'Our chimney services include cleaning, repair, and installation. Free Estimates available',
    path: '/chimney-repair',
  },
  {
    title: 'Gutters',
    icon: `/assets/img/GUTTERS-1234.svg`,
    text: 'Protect your home from water damage with our gutter installation and repair services.',
    path: '/gutters',
  },
  {
    title: 'Siding',
    icon: `/assets/img/siding.png`,
    text: 'Our team can install and repair various types of siding, including vinyl, wood, and fiber cement.',
    path: '/siding',
  },
  {
    title: 'Skylights',
    icon: `/assets/img/skylights.png`,
    text: 'Add natural light to your home with our skylight installation and repair services.',
    path: '/services/skylights',
  },
  {
    title: 'Emergency?',
    icon: `/assets/img/EMERGENCY-ROOFING.png`,
    text: 'Our team can install and repair various types of siding, including vinyl, wood, and fiber cement.',
    path: '/services/emergency-roofing',
  },
];

// TEMPORARY placeholder work photos (stock) — the original Phoenix photo host
// is offline. Swap these with the owner's real project photos when provided.
export const GALLERY = [
  { src: '/assets/work/work-1.jpg', alt: 'Roofer at work on a residential roof' },
  { src: '/assets/work/work-2.jpg', alt: 'Carrying shingles during a roof installation' },
  { src: '/assets/work/work-3.jpg', alt: 'Roof installation with power tools' },
  { src: '/assets/work/work-4.jpg', alt: 'Roofing team working on a home' },
  { src: '/assets/work/work-5.jpg', alt: 'Roof access with ladder beside chimney' },
  { src: '/assets/work/work-6.jpg', alt: 'Residential house with brick chimney' },
  { src: '/assets/work/work-7.jpg', alt: 'Brick chimney masonry work' },
  { src: '/assets/work/work-8.jpg', alt: 'New rain gutter installation' },
  { src: '/assets/work/work-9.jpg', alt: 'Asphalt shingle close-up' },
  { src: '/assets/work/work-10.jpg', alt: 'Completed home with new shingle roof' },
  { src: '/assets/work/work-11.jpg', alt: 'Completed residential exterior' },
  { src: '/assets/work/work-12.jpg', alt: 'Finished roof with chimney' },
];

export const TESTIMONIALS = [
  {
    image: `/assets/img/testimonial3.jpg`,
    quote: '\u201CAbsolutely thrilled with the service from Phoenix Roofing & Chimney! They fixed our leaky roof in no time, and the crew was incredibly professional. Highly recommend!',
    name: '- Jamie K',
  },
  {
    image: `/assets/img/unnamed-1.jpg`,
    quote: '\u201CCall them for roof repair . They change the playwood. Shingles look same like a new roof. And Edison cleaned the chimney for free. Thank you guys for the service.\u201D',
    name: '- Osmay L',
  },
  {
    image: `/assets/img/unnamed.jpg`,
    quote: '\u201CGreat roofing company.Respectful and gets the work done very fast. Would recommend anyone who needs roofing work done to go with Phoenix Roofing\u201D',
    name: '- Erickson F',
  },
];

export const FAQS = [
  {
    q: 'How Long Does a Roof Last?',
    a: 'The lifespan of a roof varies based on the materials used and the quality of installation and maintenance. Asphalt shingle roofs typically last 20-30 years. Slate, tile, and copper roofs can last more than 50 years, while wood shake roofs last around 30 years. Regular maintenance and inspections can help extend your roof\u2019s lifespan.',
  },
  {
    q: 'Can You Install Shingles Over an Existing Roof?',
    a: 'Yes, it is possible to install shingles over an existing roof, a process known as reroofing. However, it\u2019s not always recommended. Installing shingles over an old roof can add extra weight and may hide underlying issues such as rot or damage. It\u2019s best to assess the condition of the existing roof to ensure it\u2019s a viable option.',
  },
  {
    q: 'Do I Have to Work with a Licensed and Insured Roofing Company?',
    a: 'Yes, working with a licensed and insured roofing company is essential. A licensed company ensures that the contractors have the necessary training and adhere to local building codes and regulations. Insurance protects you from liability in case of accidents or damages during the project. It ensures you are working with professionals who are accountable and provide quality work.',
  },
  {
    q: 'How Do I Know I Need a New Roof?',
    a: 'Several signs indicate you might need a new roof:\n\n\u2022 Age: If your roof is approaching or has exceeded its expected lifespan.\n\u2022 Damaged or Missing Shingles: Shingles that are cracked, curling, or missing can expose your roof to water damage.\n\u2022 Leaks: Water stains on ceilings or walls often indicate roof leaks.\n\u2022 Sagging: A sagging roof deck could be a sign of structural issues.\n\u2022 Granules in Gutters: Excessive granules from shingles in gutters mean your shingles are deteriorating.\n\u2022 Daylight Through Roof Boards: If you see sunlight through roof boards in your attic, it\u2019s time for a new roof.',
  },
  {
    q: 'How Much Does a New Roof Cost?',
    a: 'The cost of a new roof depends on several factors:\n\n\u2022 Material: Asphalt shingles are the most affordable, while materials like slate, tile, and metal are more expensive.\n\u2022 Size: The larger the roof, the more it will cost.\n\u2022 Complexity: Roofs with steep pitches, multiple levels, or intricate designs cost more due to increased labour and material needs.\n\u2022 Removal of Old Roof: Removing and disposing of the old roof can add to the cost.\n\u2022 Location: Local labour rates and material availability can affect the overall price.\n\nOn average, homeowners in New Jersey can expect to pay between $5,000 and $15,000 for a new roof, depending on the above factors. For an accurate estimate tailored to your specific needs, contact us for a free in-house consultation and detailed quote.',
  },
];

export const BRANDS = [
  { src: `/assets/img/New-Project-1-2.png`, alt: 'CertainTeed' },
  { src: `/assets/img/TAMKO-pdf-removebg-preview-300x118-1-1.png`, alt: 'TAMKO Building Products' },
  { src: `/assets/img/GAF-Master-Elite-Logo-300x110-1-2.png`, alt: 'GAF Master Elite' },
  { src: `/assets/img/gaf-logo-1024x385-removebg-preview-300x113-1.png`, alt: 'GAF Certified' },
  { src: `/assets/img/Asset-18.png`, alt: 'Phoenix Roofing' },
];

export const POSTS = [
  {
    title: 'How to Choose the Right Roofing Contractor in New Jersey',
    slug: 'how-to-choose-the-right-roofing-contractor-in-new-jersey-2',
    image: `/assets/img/2025-02-09.jpg`,
    category: 'Roofing',
    excerpt: 'Choosing the right roofing contractor protects your home and your investment. Learn what to look for: licensing, insurance, local experience, manufacturer certifications, and transparent written estimates.',
  },
  {
    title: 'Residential Roof Repair Services in New Jersey',
    slug: 'residential-roof-repair-services-in-new-jersey',
    image: `/assets/img/2025-02-13-e1779997531776.jpg`,
    category: 'Roofing',
    excerpt: 'From missing shingles to flashing failures, prompt residential roof repair keeps small problems from becoming costly replacements. See how our team diagnoses and permanently fixes roof issues.',
  },
  {
    title: 'Storm Damage Roof Repair Services in New Jersey',
    slug: 'storm-damage-roof-repair-services-in-new-jersey',
    image: `/assets/img/Storm-Damage-Roof-Repair-NJ.jpg`,
    category: 'Roofing',
    excerpt: 'High winds, hail, and fallen limbs can compromise your roof overnight. Our 24/7 storm damage response team secures your home fast and works with your insurance documentation needs.',
  },
  {
    title: 'The Importance of Gutter Maintenance for Your Roof in New Jersey',
    slug: 'the-importance-of-gutter-maintenance-for-your-roof-in-new-jersey',
    image: `/assets/img/Gutter-Maintenance-NJ-2.jpg`,
    category: 'Roofing',
    excerpt: 'Clogged gutters back water up under shingles and into fascia boards. Seasonal gutter maintenance is one of the most affordable ways to extend the life of your roof.',
  },
  {
    title: 'How to Prevent Roof Leaks in New Jersey Homes',
    slug: 'how-to-prevent-roof-leaks-in-new-jersey-homes',
    image: `/assets/img/Prevent-Roof-Leaks-NJ.jpg`,
    category: 'Roofing',
    excerpt: 'Most roof leaks start small and hidden. Annual inspections, sealed flashing, clear gutters, and prompt shingle repairs keep New Jersey homes dry through every season.',
  },
  {
    title: 'Benefits of Preventive Roof Maintenance in New Jersey',
    slug: 'benefits-of-preventive-roof-maintenance-in-new-jersey',
    image: `/assets/img/Preventive-Roof-Maintenance-NJ.jpg`,
    category: 'Roofing',
    excerpt: 'Preventive maintenance costs a fraction of emergency repairs. Discover how scheduled inspections and minor tune-ups can add years to your roof\u2019s service life.',
  },
];

export const COUPONS = [
  {
    headline: '$1000 OFF',
    bold: 'New Roofs',
    text: '\u2013 When you mention our website or claim this coupon online',
  },
  {
    headline: '$1000 OFF',
    bold: 'New Siding',
    text: '\u2013 When you mention our website or claim this coupon online',
  },
  {
    headline: '$149',
    bold: 'Chimney Cleaning',
    text: 'Starting Price \u2013 When you mention our website or claim this coupon online',
  },
  {
    headline: '$99',
    bold: 'Gutter Cleaning',
    text: 'Starting Price \u2013 When you mention our website or claim this coupon online',
  },
];

export const IMAGES = {
  roofingTypes: `/assets/img/roofing-types.jpg`,
  trustHouse: `/assets/img/21a6a124.jpg`,
  ctaRoof: `/assets/img/Asset-18.png`,
  clap: `/assets/img/clap.png`,
  fiveStar: `/assets/img/5-Star-Rating-Transparent.png`,
  sidingHero: `/assets/img/siding-nj.jpg`,
  guttersImg: `/assets/img/gutters-nj.jpg`,
};

export const SERVICE_PAGES = {
  'roof-replacement': { title: 'Roof Replacement', sub: 'Professional Roof Replacement in New Jersey', desc: 'Choose from flat, asphalt shingle, slate, or metal roofing for the perfect blend of style and durability. Our roof replacement specialists deliver long-lasting protection backed by manufacturer certifications.' },
  'roof-repair': { title: 'Roof Repair', sub: 'Expert Roof Repair in New Jersey', desc: 'If the roof only needs to be repaired, our professionals have the expertise to solve the problem permanently. We repair leaks, missing shingles, flashing, and storm damage.' },
  'new-roof': { title: 'New Roof', sub: 'New Roof Installation in New Jersey', desc: 'Professional roof installation for long-lasting protection and durability. Save up to 40% on professional roof installations with your local roofing specialist.' },
  'roof-leak-repair': { title: 'Roof Leak Repair', sub: 'Roof Leak Repair in New Jersey', desc: 'Expert leak repairs to keep your home dry and damage-free. We locate the source of every leak and fix it permanently.' },
  'emergency-roofing': { title: 'Emergency Roofing', sub: '24/7 Emergency Roofing in New Jersey', desc: '24/7 emergency repair services to handle urgent roofing issues. Free Inspections \u2013 Same Day Service.' },
  'chimney-inspection': { title: 'Chimney Inspection', sub: 'Chimney Inspections in New Jersey', desc: 'Our chimney services include cleaning, repair, and installation. Free Estimates available. Protect your family with a certified chimney inspection.' },
  'chimney-cleaning': { title: 'Chimney Cleaning', sub: 'Chimney Cleaning in New Jersey', desc: 'Professional chimney sweep and cleaning services starting at $149. Keep your chimney safe and efficient all season long.' },
  'cap-crown-install': { title: 'Cap & Crown Install', sub: 'Chimney Cap & Crown Installation in New Jersey', desc: 'Protect your chimney from water intrusion and animal entry with professional cap and crown installation.' },
  'chimney-flashing-repair': { title: 'Chimney Flashing Repair', sub: 'Chimney Flashing Repair in New Jersey', desc: 'Stop leaks where your chimney meets the roof. Expert flashing repair keeps water out of your home.' },
  skylights: { title: 'Skylights', sub: 'Skylight Installation & Repair in New Jersey', desc: 'Add natural light to your home with our skylight installation and repair services.' },
};

export const MAIN_SERVICES = {
  roofing: { title: 'Roofing', sub: 'Expert Roofing Services in New Jersey', desc: 'Phoenix Roofing & Chimney proudly serves Bergen, Passaic, Hudson, Essex, Morris, Hunterdon, Somerset, Sussex, Union, and Warren Counties. Save up to 40% on roofing services.' },
  'chimney-repair': { title: 'Chimney', sub: 'Chimney Repair, Cleaning & Installation in New Jersey', desc: 'Our chimney services include cleaning, repair, and installation. Free Estimates available. Trusted chimney professionals serving all of Northern New Jersey.' },
  gutters: { title: 'Gutters', sub: 'Gutter Installation & Repair in New Jersey', desc: 'Protect your home from water damage with our gutter installation and repair services. Gutter cleaning starting at $99.' },
  siding: { title: 'Siding', sub: 'Siding Installation & Repair in New Jersey', desc: 'Our team can install and repair various types of siding, including vinyl, wood, and fiber cement.' },
};
